'use client';

import {
	default as ReactHtmlParser,
	default as reactHtmlParser,
} from 'react-html-parser';

import VideoSingle from '@/components/common/ui/single-item/VideoSingle';
import styled from 'styled-components';

const BlogList = ({ data, title, blogBody = false }) => {
	const section_data = data?.section_data || data?.data;
	const image_data = data?.images;
	const bannerimage = image_data?.list
		? image_data?.list?.find(f => f?.banner === 'on')
		: image_data?.find(f => f?.banner === 'on');
	const video = image_data?.list
		? image_data?.list?.find(f => f?.is_video === 'on')
		: image_data?.find(f => f?.is_video === 'on');
	const thumb = image_data?.list
		? image_data?.list?.filter(f => f?.thumb === 'on')
		: image_data?.filter(f => f?.thumb === 'on');
	return (
		<StyledBlogList
			className={blogBody ? 'blog-article-body' : ''}
			id={section_data?.slug ? section_data?.slug : ''}>
			<div className="image-blog-wrapper">
				{section_data?.notitle === 1 && section_data?.title && (
					<h3>{reactHtmlParser(section_data?.title)}</h3>
				)}

				{section_data?.subtitle && (
					<p>{reactHtmlParser(section_data?.subtitle)}</p>
				)}
				{section_data?.short_desc && (
					<p>{reactHtmlParser(section_data?.short_desc)}</p>
				)}
				{bannerimage && (
					<>
						<img src={bannerimage?.full_path} alt={title} />
						<p>{bannerimage?.short_title}</p>
					</>
				)}
				{video && (
					<VideoSingle
						video_id={video?.short_title}
						img={video?.full_path}
					/>
				)}
				{image_data?.list?.length > 0 ? (
					<div className="image-flex">
						{thumb?.map((e, index) => {
							return (
								<div className="single-image_data" key={index}>
									<img
										src={e?.full_path}
										alt={e?.short_title || ''}
										title={e?.short_title}
									/>
								</div>
							);
						})}
					</div>
				) : (
					''
				)}
				{section_data?.description &&
					ReactHtmlParser(section_data?.description)}
			</div>
		</StyledBlogList>
	);
};

const StyledBlogList = styled.div`
	&.blog-article-body .image-blog-wrapper p span,
	&.blog-article-body .image-blog-wrapper h3 span {
		color: inherit;
	}

	.image-flex {
		display: flex;
		gap: 15px;
		flex-wrap: nowrap;
		margin-bottom: 60px;
		justify-content: space-between;
		.single-image_data {
			flex: 0 0 calc(50% - 15px);
			max-width: calc(50% - 15px);
		}
	}

	h3 {
		margin-bottom: 20px;
	}

	p {
		font-weight: 400;
		font-size: 1rem; /* 16px */
		line-height: 1.5rem; /* 24px */
		letter-spacing: 0;
		margin-bottom: 20px;

		span {
			color: #dd223f;
		}
	}

	.image-blog-wrapper {
		margin-top: 40px;
		margin-bottom: 40px;

		h3 {
			font-weight: 500;
		}

		img {
			width: 100%;
			height: auto;
			border-radius: 10px;
		}

		p {
			margin-top: 20px;
			font-weight: 500;
		}
	}

	.video_single {
		margin: 0 0 60px;

		.video-box {
			padding-top: calc(430 / 770 * 100%) !important;
		}
	}

	blockquote {
		padding: 18px 25px;
		opacity: 0.92;
		background: rgba(150, 125, 62, 0.28);
		color: #886c37;
		font-size: 0.9rem;
		font-style: normal;
		font-weight: 300;
		line-height: 1.377rem;
		letter-spacing: -0.027rem;
		margin: 60px 0;
	}

	.round-list {
		margin-top: 40px;
		list-style: none;

		li {
			border-bottom: 1px solid rgba(21, 38, 55, 0.2);
			padding-bottom: 10px;
			margin-bottom: 10px;
			color: #152637;
			font-weight: 400;
			font-size: 1rem; /* 16px */
			line-height: 1.5rem; /* 24px */
			letter-spacing: 0em; /* 0% */
			position: relative;
			counter-increment: count;
			padding-left: 32px;
			list-style: none;

			h3 {
				font-weight: 400;
				font-size: 1.25rem; /* 20px */
				line-height: 1.5rem; /* 24px */
				letter-spacing: 0;
				margin-bottom: 10px;
			}

			p {
				margin: 0;
			}

			&:before {
				width: 20px;
				height: 20px;
				background: #dd223f;
				content: counter(count, decimal);
				font-weight: 400;
				font-size: 0.625rem; /* 10px */
				line-height: 0.75rem; /* 12px */
				letter-spacing: 0;
				text-align: center;
				position: absolute;
				color: white;
				left: 0;
				top: 5px;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
			}
		}
	}

	ul {
		list-style: disc;
		padding-left: 15px;
		margin-bottom: 60px;

		li {
			list-style: disc;
			font-size: 1rem;
			font-style: normal;
			font-weight: 400;
			line-height: 1.53rem;
			letter-spacing: -0.023rem;
			margin-bottom: 10px;

			::marker {
				color: #dd223f;
			}

			&:last-child {
				margin-bottom: 0;
			}
		}
	}

	table {
		width: 100%;
		border-collapse: collapse;
		font-weight: 400;
		font-size: 1rem; /* 16px */
		line-height: 1.5rem; /* 24px */
		letter-spacing: 0;
		color: #394149;
		margin-bottom: 60px;
	}

	tr {
		display: flex;
	}

	th,
	td {
		width: 50%; /* Each cell takes 50% */
		border-bottom: 1px solid rgba(21, 38, 55, 0.2); /* Light gray border */
		padding: 20px 0 20px;
		text-align: left;
	}

	th {
		font-weight: 700;
		padding-top: 0;
		border-bottom: 1px solid #152637; /* Light gray border */
	}

	tr:nth-child(even) {
	}

	tr:hover {
	}

	caption {
		font-size: 1.2rem;
		font-weight: 600;
		margin-bottom: 10px;
		color: #886c37;
	}
`;

export default BlogList;
